import { userStorage } from '../lib/userStorage';

export const PROGRESS_SOURCE_KEY = 'progress_source';
export const MANUAL_PROGRESS_COLLEGES_KEY = 'progress_manual_colleges';
export const DASHBOARDS_KEY = 'app_dashboards';

export const DEFAULT_PROGRESS_SOURCE = {
  mode: 'manual',
  dashboardId: null,
};

export function getProgressCollegeStorageId(collegeName) {
  return collegeName.replace(/\s+/g, '_');
}

export function getProgressTasksKey(collegeName) {
  return `progress_tasks_${getProgressCollegeStorageId(collegeName)}`;
}

export function getProgressMetaKey(collegeName) {
  return `progress_meta_${getProgressCollegeStorageId(collegeName)}`;
}

function readJson(key, fallback) {
  try {
    const raw = userStorage.getItem(key);
    return raw ? JSON.parse(raw) : fallback;
  } catch {
    return fallback;
  }
}

export function readProgressSource() {
  const source = readJson(PROGRESS_SOURCE_KEY, DEFAULT_PROGRESS_SOURCE);
  if (!source || !['none', 'dashboard', 'manual'].includes(source.mode)) {
    return DEFAULT_PROGRESS_SOURCE;
  }

  return {
    mode: 'manual',
    dashboardId: null,
  };
}

export function readStoredDashboards() {
  return readJson(DASHBOARDS_KEY, []);
}

export function readManualProgressColleges() {
  const colleges = readJson(MANUAL_PROGRESS_COLLEGES_KEY, []);
  return Array.isArray(colleges)
    ? [...new Set(colleges.filter(Boolean))]
    : [];
}

export function getDashboardProgressColleges(dashboards, dashboardId) {
  const dashboard = dashboards.find((dash) => dash.id === dashboardId);
  if (!dashboard) return [];

  const seen = new Set();
  const colleges = [];

  try {
    const raw = userStorage.getItem(`dashboard_${dashboard.id}_rows`);
    if (!raw) return [];

    const rows = JSON.parse(raw);
    if (!Array.isArray(rows)) return [];

    rows.forEach((row) => {
      const name = row.schoolData?.['latest.school.name'];
      if (name && !seen.has(name)) {
        seen.add(name);
        colleges.push({
          name,
          dashboardName: dashboard.name,
          category: row.category || null,
        });
      }
    });
  } catch {
    return [];
  }

  return colleges;
}

export function getManualProgressCollegeObjects(manualColleges = readManualProgressColleges()) {
  return manualColleges.map((name) => ({
    name,
    dashboardName: 'Manual',
    category: null,
    source: 'manual',
  }));
}

export function getVisibleProgressColleges() {
  return getManualProgressCollegeObjects();
}
